import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';

declare let $: any;


@Component({

  selector: 'app-taxilon-search',

  templateUrl: './taxilon-search.component.html',

  styleUrls: ['./taxilon-search.component.css']

})

export class TaxilonSearchComponent implements OnInit {

  lst_Trips: any[] = [];

  lst_Search: any = [];

  iFinalRent: number = 0;

  iCommission: number = 0;

  iDebitCredit: number = 0;

  bEditMode: boolean | 'showMode' | 'searchMode' = false;

  showFilter: boolean = false;

  isCity: boolean = false;

  list_MobileType: any[] = [];

  list_MobileGroup: any[] = [];

  list_Reason: any[] = [];

  list_ReliefType: any[] = [];

  lst_City: any = [];

  lst_GroupCar: any = [];

  list_Driver: any[] = [];

  list_TripStatus: any[] = [];

  list_SystemUser: any[] = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strSDate: new FormControl(moment().subtract(30, 'day').format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(''),

    strUnitID: new FormControl(''),

    tiTripStatus: new FormControl(-1),

    iSystemUser_User: new FormControl(-1),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({
    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),
    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),
    iTaxiLon_Trip: new FormControl(''),
    strName: new FormControl('', Validators.required), //  نام مسافر
    strFamily: new FormControl('', Validators.required), //  فامیل مسافر 
    strMobile: new FormControl('', Validators.required), //  موبایل مسافر
    tiSex: new FormControl(1, Validators.required), //  جنسیت 
    strID: new FormControl(''), //  کد ملی
    bForAnother: new FormControl(false), //  برای دیگری
    strPassengersName: new FormControl(''), //  نام مسافر دیگر
    strDate: new FormControl('', Validators.required), //  تاریخ سفر
    strTime: new FormControl('', Validators.required), //  ساعت سفر
    strSCity: new FormControl('', Validators.required), //  شهر مبدا
    fSLon: new FormControl('', Validators.required),
    fSLat: new FormControl('', Validators.required),
    strSAddress: new FormControl('', Validators.required),
    strDCity: new FormControl('', Validators.required), //  شهر مقصد
    fDLon: new FormControl('0'),
    fDLat: new FormControl('0'),
    strDAddress: new FormControl(''),
    bCameBack: new FormControl(false), //  دارای برگشت 
    bHasStop: new FormControl(false), //  داری توقف
    fEstimateStop: new FormControl(''), //  مدت توقف مثلا 3.5 ساعت 
    tiPassenger: new FormControl(1), //  تعداد مسافر
    bCargo: new FormControl(false), //  بار دارد
    strCargoDetail: new FormControl(''), //  توضیحات بار
    bPet: new FormControl(false), //  حیوان خانگی 
    bSmoking: new FormControl(false), //  سیگار مجاز
    bNeedHelp: new FormControl(false), //  نیاز به کمک 
    bInvoiceRequired: new FormControl(false), //  نیاز به فاکتور
    strCompany: new FormControl(''), //  اسم شرکت برای فاکتور
    bForeigner: new FormControl(false), //  مسافر غیر ایرانی
    strPassportNumber: new FormControl(''), //  شماره پاسپورت مسافر غیر ایرانی 
    strComment: new FormControl(''), //  توضیحات
    tiMobileGroup: new FormControl('', Validators.required), //  گروه خودرویی
    iEstimateRent: new FormControl(0, Validators.required), //  کرایه
    strUnitID: new FormControl(''), // شناسه خودرو
    strDriver_FullName: new FormControl(''), // نام راننده
    strDriver_Mobile: new FormControl(''), // موبایل راننده
    fEstimateKm: new FormControl(''), //  مسافت
    tiCommissionPercentage: new FormControl(''), //  درصد کمیسیون
    iAdvancePayment: new FormControl(''), //  مقدار پیش پرداخت
    _fKm: new FormControl(''), //  مسافت
    _strTime: new FormControl(''), //  مدت زمان سفر
    _index: new FormControl('-1')

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _mapService: MapService

  ) { }

  ngOnInit(): void {

    this.getMobileGroup();

    this.city_TaxiLon();

  }

  async search_Trip() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_Trip_ORG_Search`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Trips = res;

    this.lst_Search = res;

    this.iFinalRent = 0;

    this.iCommission = 0;

    this.iDebitCredit = 0;

    this.lst_Trips.forEach((el: any) => {

      this.iFinalRent += el.iFinalRent;

      this.iCommission += el.iCommission;

      this.iDebitCredit += el.iDebitCredit;

    })

  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  filter_list(val: any) {

    this.lst_Trips = this.lst_Search.filter((el: any) => {

      return el?.strSystemUser_FullName?.includes(val.value) ||

        el.strTaxiLon_TripStatus_strComment.includes(val.value) ||

        el.strDCityName.includes(val.value) ||

        el.strSCityName.includes(val.value) ||

        el.strFullName.includes(val.value) ||

        el.strMobile.includes(val.value) ||

        el.strDriver_Mobile.includes(val.value) ||

        el.strDriver_FullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Trips = this.lst_Search;

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'جستجوی سفر.xlsx');
  }

  showMap() {

    if (!this.lst_Trips.length) return this._tooltip.showError('نتیجه ایی یافت نشد!');

    window.localStorage.removeItem('x5SBJaw');

    window.localStorage.setItem("x5SBJaw", this.gurdService.encrypt(JSON.stringify(this.lst_Trips)));

    window.open('/emdadran/search-requests/map', '_blank')

  }

  showTripRoute(item: any) {

    if (item.tiTripStatus < 4 || item.tiTripStatus > 8) return this._tooltip.showError('امکان مشاهده مسیر وجود ندارد!')

    window.open(`route/${item.strUnitID}`, '_blank')

    window.localStorage.setItem("RouteDate", this.gurdService.encrypt(item.strDate));

    window.localStorage.setItem("reportStime", this.gurdService.encrypt(item.strSTripTime));

    window.localStorage.setItem("reportEtime", this.gurdService.encrypt(item.strETripTime));

    window.localStorage.setItem("UnitID", this.gurdService.encrypt(item.strUnitID.toString()));

    window.localStorage.setItem("carName", this.gurdService.encrypt(item.strFullName.toString()));

    window.localStorage.setItem("plate", this.gurdService.encrypt(item.strVehicleNo.toString()));

  }

  newRequest(item: any = {}, index: number = -1, mode?: 'showMode') {

    if (item?.iTaxiLon_Trip) {

      Object.keys(item).forEach((key) => {

        this.mdl_Request.get(key)?.setValue(item[key]);

      })

      this.mdl_Request.get('_index')?.setValue(index);

      this.mdl_Request.get('_fKm')?.setValue('');

      this.mdl_Request.get('_strTime')?.setValue('');

      this.bEditMode = mode ? 'showMode' : true;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#newReq_Modal").modal("show");

    }

  }

  getMobileGroup = async () => {

    this._otherService.Showspinner();

    let res = (await axios.post(`GetMobileType`, {})).data;

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.list_MobileType = res;

    // ---------------------------------------------------------------

    let res_2 = JSON.parse((await axios.post(`GetMobileGroup`)).data);

    if (res_2.bError || res_2.iResult == 0) return this._tooltip.showError(res_2.strError);

    this.list_MobileGroup = res_2;

    // ---------------------------------------------------------------

    let res_3 = JSON.parse((await axios.post(`Reason4Request`)).data);

    if (res_3.bError || res_3.iResult == 0) return this._tooltip.showError(res_3.strError);

    this.list_Reason = res_3;

    // ------------------------------------------------------------------------

    let res_4 = JSON.parse((await axios.post(`ReliefRequestType`)).data);

    this._otherService.nonespinner();

    if (res_4.bError || res_4.iResult == 0) return this._tooltip.showError(res_4.strError);

    this.list_ReliefType = res_4;

    // ------------------------------------------------------------------------

    let res_5 = JSON.parse((await axios.post(`Peysepar_Mobile_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    if (res_5.bError || res_5.iResult == 0) return this._tooltip.showError(res_5.strError);

    this.list_Driver = res_5;

    // ------------------------------------------------------------------------

    let res_6 = JSON.parse((await axios.post(`TaxiLon_TripStatus_list`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    if (res_6.bError || res_6.iResult == 0) return this._tooltip.showError(res_6.strError);

    this.list_TripStatus = res_6;

    // ------------------------------------------------------------------------

    let res_7 = JSON.parse((await axios.post(`TaxiLon_SystemUser_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res_7.bError || res_7.iResult == 0) return this._tooltip.showError(res_7.strError);

    this.list_SystemUser = res_7;


  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  city_TaxiLon = async () => {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`TaxiLon_City_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data);

    this._otherService.nonespinner();

    if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_City = res;


    // ------------------------------------------------------------- >

    this._otherService.Showspinner();

    const resp = await axios.post(`GetMobileGroup`, {});

    resp.data = JSON.parse(resp.data);

    this._otherService.nonespinner();

    if (resp.data.bError || resp.data.iResult == 0) return this._tooltip.showError(resp.data.strError);

    this.lst_GroupCar = resp.data;



  }

  putSeprator(number: number | string, mode: 'showMode' | 'searchMode' | boolean): string | number {

    if (mode == 'showMode' || mode) {

      return number.toLocaleString();

    }

    else {
      return number
    }

  }


}
